import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import GET_RFP_PERMISSIONS from '../api/graphql/rfp/queries/get-rfp-permissions';
import { ApolloInstances } from '../api';
import { RfpAndOffersPermissionResult } from '../types/permissions/rfp-and-offers-permission-result';

@Injectable({
  providedIn: 'root',
})
export class RfpPermissionsService {
  constructor(private apollo: Apollo) {}
  getRfpPermissions(rfpId: number) {
    return this.apollo
      .use(ApolloInstances.RFP)
      .query<{ permissions: RfpAndOffersPermissionResult[] }>({
        variables: { rfpId },
        query: GET_RFP_PERMISSIONS,
      })
      .pipe(map((request) => request.data.permissions));
  }
}
